import KeyCode from '@root/core/src/utils/keycode';

export function clickOnSpace(e) {
  if (e.keyCode === KeyCode.KEYCODES.SPACE) {
    e.target.click();
  }
}
